import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
// Component
import CancellationPolicy from '../../components/CancellationPolicies';

import s from './Policies.css';
import { useQuery } from '@apollo/client';
import { getCancellationInfo, getCancellationPolicies } from '../../lib/graphql';
import { getDynamicPolicyInfo, getDynamicPolicyName } from '../../helpers/GetDynamicItemName/getDynamicName';
import { useIntl } from 'react-intl';

const Policies = (props) => {
	const { policyType } = props;
	const { data, loading } = useQuery(getCancellationPolicies, {
		fetchPolicy: 'network-only',
		ssr: false
	})
	const { data: CancellationInfoData, loading: cancellationInfoLoading } = useQuery(getCancellationInfo, {
		fetchPolicy: 'network-only',
		ssr: false
	})

	const { locale } = useIntl()

	let result = CancellationInfoData?.getCancellationInfo?.results[0]
	let dynamicCancellationInfo = !cancellationInfoLoading && result?.dynamicCancellationInfo?.length > 0 ?
		getDynamicPolicyInfo({ locale, data: result?.dynamicCancellationInfo }) : result

	const policies = data?.getCancellationPolicies?.results || []
	const localizedPolicies = policies.reduce((acc, policy) => {
		const localized = getDynamicPolicyName({ locale, data: policy?.dynamicCancellationContent, value: policy })
		acc[policy.id] = localized
		return acc
	}, {})

	return (
		<div className={s.root}>
			<div className={s.container}>
				<CancellationPolicy policyType={policyType} policies = {policies} cancellationInfo={dynamicCancellationInfo?.description} localizedPolicies={localizedPolicies} />
			</div>
		</div>
	);
}


export default withStyles(s)(Policies);
